import { lazy } from 'react';

export const KYC = lazy(() => import('./KYC.component'));
